<template>
  <component
    class="jade-text"
    :class="computedClassList"
    :is="as"
    v-bind="$attrs"
  >
    <slot />
  </component>
</template>

<script>
import COLOR_ENUM from '../enums/colors.enum'
import WEIGHT_ENUM from '../enums/weight.enum'

const TEXT_SIZE = ['text-small', 'text-medium', 'text-large']

export default {
  name: 'JadeText',

  props: {
    as: {
      type: String,
      default: 'p'
    },
    color: {
      type: String,
      validation: c => Object.values(COLOR_ENUM).includes(c)
    },
    variant: {
      type: String,
      default: 'text-medium',
      validation: variant =>
        [
          ...TEXT_SIZE,
          'overline',
          'heading-xsmall',
          'heading-small',
          'heading-medium',
          'heading-large',
          'display-small',
          'display-medium',
          'hyperlink-small',
          'hyperlink-medium',
          'hyperlink-large'
        ].includes(variant)
    },
    weight: {
      type: String,
      validation: weight =>
        [
          WEIGHT_ENUM.REGULAR,
          WEIGHT_ENUM.MEDIUM,
          WEIGHT_ENUM.SEMI_BOLD,
          WEIGHT_ENUM.BOLD
        ].includes(weight),
      default: WEIGHT_ENUM.REGULAR
    }
  },

  computed: {
    defineColor () {
      const selfColor = this.color || this.defineDefaultColor()
      if (selfColor === COLOR_ENUM.ON_BRAND) return 'color-on-brand-high'
      if (selfColor === COLOR_ENUM.ON_COLOR) return 'color-on-color-high'

      return `color-${selfColor}`
    },

    defineWeight () {
      return TEXT_SIZE.includes(this.variant) ? `weight-${this.weight}` : ''
    },

    computedClassList () {
      return {
        [`is-${this.defineColor}`]: this.defineColor,
        [`is-${this.defineWeight}`]: this.defineWeight,
        [`is-${this.variant}`]: this.variant
      }
    }
  },

  methods: {
    defineDefaultColor () {
      return this.variant?.startsWith('hyperlink')
        ? COLOR_ENUM.BRAND
        : COLOR_ENUM.HIGH
    }
  }
}
</script>

<style scoped>
@import '@stone-payments/jade/css/text.css';
</style>
